import { Link } from "react-router-dom";
import "./styles/Footer.css";

import { useTranslation } from "react-i18next";
import "../localisation/index"
const Footer = () => {
  const {t} = useTranslation()
  return (
    <div className="app-footer">
      <Link to={"privacy-policy"} className="app-footer__items">
        {t("footer.privacy")}
      </Link>
      <Link to={"terms-and-conditions"} className="app-footer__items">
        {t("footer.terms")}
      </Link>
      <span className="app-footer__items">{t("footer.copyright")}</span>
    </div>
  );
};

export default Footer;
